/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { ToolbarComponentCommonProps } from '..';

export const SelectAllToggle = (props: ToolbarComponentCommonProps) => {
  const { toggleSelectAll, isSelectAll } = props;

  if (!toggleSelectAll) {
    return null;
  }

  return (
    <div className='text-right'>
      <Button color='link' size='sm' onClick={() => toggleSelectAll()}>
        {isSelectAll ? 'Unselect all' : 'Select all'}
      </Button>
    </div>
  );
}
